import { put } from 'redux-saga/effects';
import http from "axios/index";

import {
    GET_EMPLOYEES,
    UPDATE_EMPLOYEE
} from '../../../api/constants'

import {
    getEmployeesSuccessful,
    getEmployeesFailure,
    removeSession,
    updateEmployeeSuccessful,
    updateEmployeeFailure,
} from '../../actions'

export function* getEmployees({ payload }) {
    try {
        let body = new URLSearchParams();
        body.append("accessToken", payload);
        const response = yield http.post(GET_EMPLOYEES, body);
        if (!response.data.err) {
            yield put(getEmployeesSuccessful(response.data.data));
        } else {
            yield put(getEmployeesFailure(response.data.data));
        }
    } catch (error) {
        yield put(removeSession());
        console.error("Error happened when try to get employee.Error : ", error)
    }
}

export function* updateEmployee({ token }) {
    try {
        let body = new URLSearchParams();
        body.append("accessToken", token);
        const response = yield http.post(UPDATE_EMPLOYEE, body);
        if (!response.data.err) {
            yield put(updateEmployeeSuccessful());
        } else {
            yield put(updateEmployeeFailure());
        }
    } catch (error) {
        console.error("Error happened when try to update employee.Error : ", error)
    }
}
